import dayjs from 'dayjs';
import { formatDate } from 'utilities/datesAndTimes';

import EditOfferPaymentModal from '../EditOfferPaymentModal';
import { setPaymentPlan, useRecoveriesState } from './recoveriesState';

const RecoveriesEditPaymentModal = (props) => {
  const { paymentPlan, offer } = useRecoveriesState();
  const isOfferSetup = !offer.state;

  const getCurrentPayments = () => {
    if (isOfferSetup) {
      return paymentPlan?.current;
    }
    return paymentPlan?.updatedFuture?.length
      ? paymentPlan?.updatedFuture
      : paymentPlan?.future;
  };

  const handleEdit = (initialDate, payment) => {
    const currentPayments = getCurrentPayments();
    const updatedPayments = currentPayments
      .map((p) =>
        dayjs(p.date).isSame(dayjs(initialDate))
          ? { ...payment, status: 'edit' }
          : p,
      )
      .sort((a, b) => dayjs(a.date) - dayjs(b.date));

    setPaymentPlan({
      ...paymentPlan,
      current: updatedPayments,
      updatedFuture: updatedPayments,
    });
  };

  const handleAdd = (payment) => {
    const currentPayments = getCurrentPayments();
    const updatedPayments = [
      ...currentPayments,
      { ...payment, status: 'add' },
    ].sort((a, b) => dayjs(a.date) - dayjs(b.date));

    setPaymentPlan({
      ...paymentPlan,
      current: updatedPayments,
      updatedFuture: updatedPayments,
    });
  };

  const handleDelete = (initialDate) => {
    const currentPayments = getCurrentPayments();

    const updatedPayments = currentPayments.reduce((acc, payment) => {
      const key = formatDate(dayjs(payment.date));
      const value = !dayjs(payment.date).isSame(dayjs(initialDate))
        ? payment
        : { ...payment, status: 'delete' };

      acc[key] = value;
      return acc;
    }, {});

    const newUpdatedFuture = Object.values(updatedPayments);

    const pendingDeletedPayment = newUpdatedFuture.filter(
      (payment) => payment?.status === 'delete',
    );

    setPaymentPlan({
      ...paymentPlan,
      current: newUpdatedFuture,
      pendingDeleted: [
        ...paymentPlan?.pendingDeleted,
        ...pendingDeletedPayment,
      ],
      updatedFuture: newUpdatedFuture,
    });
  };

  return (
    <EditOfferPaymentModal
      {...props}
      expirationDate={offer?.expiration}
      onEditPayment={handleEdit}
      onAddPayment={handleAdd}
      onDeletePayment={handleDelete}
    />
  );
};

export default RecoveriesEditPaymentModal;
